export default {
    'ERROR-GET-CAMPAIGN-DASHBOARD-DATA': {
        'CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne non trouvée.",
                en: 'Campaign not found.',
            },
            redirectPath: '/campaigns',
        },
        'ORGANIZATION-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Organisation non trouvée.",
                en: 'Organization not found.',
            },
            redirectPath: '/campaigns',
        },
        'CAMPAIGN-ARCHIVED': {
            actionType: 'redirect',
            message: {
                fr: "Campagne archivée.",
                en: 'Campaign archived.',
            },
            redirectPath: '/campaigns',
        },
    },
};
